import { MerchantProcessorAccountDto } from "@admin_api/models/merchant-processor-account-dto";

export class AccountsState {
    loading = false;
    error = null;
    record: Array<MerchantProcessorAccountDto> = [];
}
